<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="#888"
          dark
          v-bind="attrs"
          v-on="on"
          text
          small
          class="mt-3"
        >
          Esqueci minha Senha
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          <v-icon class="mr-4" @click="fechar()">mdi-close</v-icon>
          Esqueci minha senha
          <v-spacer />
          <span id="partes">Etapa {{ etapa + 1 }} de 3</span>
        </v-card-title>

        <v-card-text class="mt-8">
          <v-text-field
            v-if="etapa === 0"
            v-model="usuario.email"
            label="Informe e-mail"
            outlined
            autofocus
            :error-messages="error === '' ? emailErrors : error"
            @input="$v.usuario.email.$touch()"
            @blur="$v.usuario.email.$touch()"
            @keypress.enter="proximo()"
          ></v-text-field>
          <v-text-field
            v-if="etapa === 1"
            v-model="usuario.codigo"
            label="Informe o código"
            outlined
            autofocus
            counter="6"
            :error-messages="error === '' ? codigoErrors : error"
            @input="$v.usuario.codigo.$touch()"
            @blur="$v.usuario.codigo.$touch()"
            @keypress.enter="proximo()"
          ></v-text-field>
          <p style="cursor: help">
            {{ dica }}
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="etapa === 1" color="default" text @click="etapa--;usuario.codigo='';">
            <v-icon>mdi-skip-previous</v-icon>
            Voltar
          </v-btn>
          <v-btn color="primary" text @click="proximo()">
            {{ infoButton }}
            <v-icon v-if="etapa < 2">mdi-skip-next</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import UsuarioAPI from "./../api/usuario";

export default {
  data: () => {
    return {
      dialog: false,
      etapa: 0,
      usuario: {
        email: "",
        codigo: "",
      },
      error: "",
    };
  },

  validations: {
    usuario: {
      email: {
        required,
        email,
      },
      codigo: {
        required() {
          if (this.etapa === 1) {
            if (this.usuario.email != "") {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        },
        minLength() {
          if (this.etapa === 1) {
            const valor = parseInt(this.usuario.codigo);

            if (valor >= 100000 && valor <= 999999) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        },
      },
      error(){
        if(this.error === "") return true;
        else return false;
      }
    },
  },

  computed: {
    dica() {
      if (this.etapa === 0) {
        return "O e-mail informado deve ser idêntico ao cadastrado neste sistema.";
      } else if (this.etapa === 1) {
        return "Enviamos um código para o seu endereço de e-mail, por favor informe-o no campo acima.";
      } else {
        return "Verifique seu e-mail, lhe enviamos sua nova senha gerada aleatóriamente.";
      }
    },
    infoButton() {
      return this.etapa <= 1 ? "Próximo" : "Pronto";
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.usuario.email.$dirty) return errors;
      !this.$v.usuario.email.email && errors.push("Email incorreto.");
      !this.$v.usuario.email.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    codigoErrors() {
      const errors = [];
      if (!this.$v.usuario.codigo.$dirty) return errors;
      !this.$v.usuario.codigo.minLength &&
        errors.push("O código é um número com 6 caracteres");
      !this.$v.usuario.codigo.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    email() {
      return this.usuario.email;
    },
    codigo() {
      return this.usuario.codigo;
    },
  },

  watch: {
    dialog() {
      this.$emit("esqueci-minha-senha", this.dialog);
    },
    email() {
      this.error = "";
    },
    codigo() {
      this.error = "";
    },
  },

  methods: {
    fechar: function () {
      this.etapa = 0;
      this.dialog = false;
      this.usuario.email = "";
      this.usuario.codigo = "";
      this.$v.$reset();
    },
    proximo: function () {
      if (this.etapa === 0) {
        this.verificarEmail();
      } else if (this.etapa === 1) {
        this.verificarCodigo();
      } else {
        this.fechar();
      }
    },
    verificarEmail: function () {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.verificarEmail(headers, this.usuario)
            .then(() => {
              this.etapa++;
              this.$v.$reset();
              this.error = "";
            })
            .catch((error) => {
              if (error.response.status == 404) {
                this.error = "E-mail inexistente em nossa base de dados.";
              } else {
                this.error =
                  "Entre em contato com o suporte, redefinição de senha indisponível no momento.";
              }

              this.Helpers.logout();
            })
        );
      }
    },
    verificarCodigo: function () {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.verificarCodigo(headers, this.usuario)
            .then(() => {
              this.etapa++;
              this.$v.$reset();
              this.error = "";
            })
            .catch(() => {
              this.error = "Código de recuperação de senha incorreto.";
              this.Helpers.logout();
            })
        );
      }
    },
  },
};
</script>

<style scoped>
#partes {
  color: #888;
  font-size: 13.5px;
}
</style>